import { render, staticRenderFns } from "./EditRegUser.vue?vue&type=template&id=9545c9f0&scoped=true"
import script from "./EditRegUser.vue?vue&type=script&lang=js"
export * from "./EditRegUser.vue?vue&type=script&lang=js"
import style0 from "./EditRegUser.vue?vue&type=style&index=0&id=9545c9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9545c9f0",
  null
  
)

export default component.exports